<template>
  <div class="hands-container">
    <a class="back-button" @click="goBack">⬅ {{back_label[language]}}</a>

    <div class="game-stats">
      <div class="game-info">{{score_label[language]}}: {{ score }}</div>
      <div class="timer">{{ timeleft_label[language] }}: {{ timeLeft }}s</div>
    </div>

    <div class="ar-view">
      <video id="input_video" autoplay playsinline></video>
      <canvas id="output_canvas"></canvas>
    </div>

    <!-- Food Image at Random Position -->
    <div class="food-target" v-if="currentFood" :style="{ top: `${foodPosition.y}%`, left: `${foodPosition.x}%` }">
      <img :src="currentFood.src" :alt="currentFood.name" class="food-image" />
    </div>

    <!-- <div class="angle-display">
      <div class="game-info"> Angle: {{ computedAngle.toFixed(2) }}°</div>
    </div> -->

    <MorningWinOverlay :message="overlayMessage[language]" :visible="isMorningWinOverlayVisible" />
    <MorningLoseOverlay :message="overlayMessage[language]" :visible="isMorningLoseOverlayVisible" />
    <NoonWinOverlay :message="overlayMessage[language]" :visible="isNoonWinOverlayVisible" />
    <NoonLoseOverlay :message="overlayMessage[language]" :visible="isNoonLoseOverlayVisible" />
    <AfternoonWinOverlay :message="overlayMessage[language]" :visible="isAfternoonWinOverlayVisible" />
    <AfternoonLoseOverlay :message="overlayMessage[language]" :visible="isAfternoonLoseOverlayVisible" />
    <EveningWinOverlay :message="overlayMessage[language]" :visible="isEveningWinOverlayVisible" />
    <EveningLoseOverlay :message="overlayMessage[language]" :visible="isEveningLoseOverlayVisible" />
    <ProfPepOverlay :message="overlayMessage[language]" :visible="isOverlayVisible" @start-game="onStartGame" />
    <div v-if="cueMessage" class="cue-message">{{ cueMessage[language] }}</div>
    <div v-if="badgeMessage" :class="['badge', badgeType]">{{ badgeMessage }}</div>
  </div>
</template>

<script>
import { Camera } from "@mediapipe/camera_utils";
import { Pose } from "@mediapipe/pose";
import ProfPepOverlay from '@/components/ProfPepOverlay.vue';
import MorningWinOverlay from '@/components/MorningWinOverlay.vue';
import MorningLoseOverlay from '@/components/MorningLoseOverlay.vue';
import NoonWinOverlay from '@/components/NoonWinOverlay.vue';
import NoonLoseOverlay from '@/components/NoonLoseOverlay.vue';
import AfternoonWinOverlay from '@/components/AfternoonWinOverlay.vue';
import AfternoonLoseOverlay from '@/components/AfternoonLoseOverlay.vue';
import EveningWinOverlay from '@/components/EveningWinOverlay.vue';
import EveningLoseOverlay from '@/components/EveningLoseOverlay.vue';
import { Howler } from 'howler';
import { sounds } from '@/utils/sounds';

export default {
  components: {
    ProfPepOverlay,
    MorningWinOverlay,
    MorningLoseOverlay,
    NoonWinOverlay,
    NoonLoseOverlay,
    AfternoonWinOverlay,
    AfternoonLoseOverlay,
    EveningWinOverlay,
    EveningLoseOverlay,
  },
  name: "FramesGame",
  data() {
    return {
isShuttingDown: false,
      back_label : {en:"Back", el:"Πίσω", it:"Indietro", ro:"Înapoi", uk:"Назад"},
     Round_label: {en:"Round", el:"Γύρος", it:"Round", ro:"Rundă", uk:"Раунд"},
      timeleft_label: {en:"Time left", el:"Χρόνος", it:"Tempo rimanente", ro:"Timp rămas", uk:"Час залишився"},
      score_label: {en:"Score", el:"Πόντοι", it:"Punteggio", ro:"Scor", uk:"Очки"},
      correct_label: {en:"Correct!", el:"Σωστά!", it:"Corretto", ro:"Corect!", uk:"Правильно!"},
      wrong_label: {en:"Wrong...", el:"Λάθος...", it:"Sbagliato", ro:"Greșit...", uk:"Неправильно..."},

      isSyncing: false,

      computedAngle: 0,
      isBodyUp: false,
      audio: null,
      camera: null,
      scoreThreshold: 60,
      daypart: '', // Initialize daypart
      score: 0,
      timeLeft: 60,
      timer: null,
      frameTimer: null,
      badgeMessage: '',
      badgeType: '',
      cueMessage: 'This is the cue message',
      frame: {},
      frameStartTime: 0,
      gamePhase: 'initialization',
      overlayMessage: {en:'This is the message',el:"Αυτό είναι το μήνυμα"},
      isOverlayVisible: true,
      isMorningWinOverlayVisible: false,
      isMorningLoseOverlayVisible: false,
      isNoonWinOverlayVisible: false,
      isNoonLoseOverlayVisible: false,
      isAfternoonWinOverlayVisible: false,
      isAfternoonLoseOverlayVisible: false,
      isEveningWinOverlayVisible: false,
      isEveningLoseOverlayVisible: false,
      foods: [],
      currentFood: null,
      distance1: null,
      distance2: null,
      distance3: null,
      foodX: null,
      foodY: null,
      foodPosition: { x: 50, y: 10 },
      categories: {
        fruits: [
          {
            name: "star",
            src: require("@/assets/game-elements/star.png"),
          },
        ],
      },

    };
  },

  methods: {
    async goBack() {
      // Guard: if overlay is visible, just go back, don't end the game
      if (this.isOverlayVisible) {
        sounds.whoosh.play();
        this.$router.push({ name: 'GameSelection' });
        return;
      }
      sounds.whoosh.play();
      this.isShuttingDown=true;
      if (sounds.drums_for_games_extended) {
        sounds.drums_for_games_extended.stop();
      }
      clearInterval(this.timer);
      clearInterval(this.frameTimer);

      if (this.camera) {
        try {
          this.camera.stop();
        } catch (e) {
          console.error("Camera stop failed on unmount:", e);
        }
      }

      // Optionally nullify the camera and pose to prevent further usage
      this.camera = null;

      if (this.pose) {
        this.pose.close(); // dispose pose properly if using pose.setOptions() instance
        this.pose = null;
      }

      // End the game as if the time ran out
      await this.endGame();
    },

    startGame() {
      this.cueMessage = {en:'Get ready!', el:'Ετοιμάσου!', it:'Preparati!', ro:'Pregătește-te!', uk:'Приготуйся!'};
      this.overlayMessage = {en:'Get ready for sit-ups!', el:'Ετοιμάσου για κοιλιακούς!', it:'Preparati per i sit-up!', ro:'Pregătește-te pentru abdomene!', uk:'Приготуйся до скручувань!'};
      this.isOverlayVisible = true;
      this.initializePoseDetection();
    },
    onStartGame() {
      this.foods = Object.values(this.categories).flat();
      this.currentFood = this.foods[0];
      this.FoodUpPosition();
      // Resume Howler context to allow audio playback
      Howler.ctx.resume();
      // Hide the overlay and start the game logic
      this.isOverlayVisible = false;
      this.score = 0;

      this.cueMessage = {en:'Lift with your core and lower yourself back down smoothly!', el:'Σήκωσε τον κορμό σου και κατέβασε τον πίσω ομαλά!', it:'Sollevati con il core e abbassati delicatamente!', ro:'Ridică-te cu centrul tău și coboară-te înapoi ușor!', uk:'Піднімися з пресом і плавно опустись назад!'};
      this.resetGame();

      this.timeLeft = 60;
      this.startTimer();
      this.generateFrame();

      // Play a sound
      sounds.get_ready.play();
      setTimeout(() => {
        sounds.drums_for_games_extended.play();
      }, 2000);
    },


    FoodUpPosition() {
      this.foodPosition.x = 50; // 10% to 90% of the width
      this.foodPosition.y = 30; // 10% to 90% of the height
    },

    FoodDownPosition() {
      this.foodPosition.x = 50; // 10% to 90% of the width
      this.foodPosition.y = 75; // 10% to 90% of the height
    },



    resetGame() {
      this.score = 0;
      this.timeLeft = 60;
      this.gamePhase = 'initialization';
      this.frame = {};
      clearInterval(this.frameTimer);
    },

    startTimer() {
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.timeLeft--;
        if (this.timeLeft <= 0) {
          clearInterval(this.timer);
          clearInterval(this.frameTimer);
          this.endGame();
        }
      }, 1000);
    },

    initializePoseDetection() {
      const videoElement = document.getElementById('input_video');
      const canvasElement = document.getElementById('output_canvas');
      const canvasCtx = canvasElement.getContext('2d');

      videoElement.width = window.innerWidth;
      videoElement.height = window.innerHeight;
      canvasElement.width = window.innerWidth;
      canvasElement.height = window.innerHeight;

      const pose = new Pose({
        locateFile: (file) => `https://cdn.jsdelivr.net/npm/@mediapipe/pose/${file}`,
      });

      pose.setOptions({
        modelComplexity: 0,
        smoothLandmarks: true,
        enableSegmentation: false,
        minDetectionConfidence: 0.5,
        minTrackingConfidence: 0.5,
      });

      pose.onResults((results) => {
        canvasCtx.clearRect(0, 0, canvasElement.width, canvasElement.height);
        canvasCtx.drawImage(
          results.image,
          0,
          0,
          canvasElement.width,
          canvasElement.height
        );

        if (results.poseLandmarks) {
          this.drawLandmarks(results.poseLandmarks, canvasCtx);
          this.processPose(results.poseLandmarks);
        }
      });

      this.camera = new Camera(videoElement, {
        onFrame: async () => {
          if (this.isShuttingDown) return; // Don't send if shutting down
          if (videoElement.readyState >= 2) {
            try {
              await pose.send({ image: videoElement });
            } catch (e) {
              console.error("Error during pose.send:", e);
            }
          }
        },
        width: 320,
        height: 180,
      });

      this.camera.start();
    },

    drawLandmarks(landmarks, ctx) {
      landmarks.forEach((landmark, index) => {
        ctx.beginPath();
        ctx.arc(
          landmark.x * ctx.canvas.width,
          landmark.y * ctx.canvas.height,
          5,
          0,
          2 * Math.PI
        );
        // Check if the current landmark is landmark 25 or 26
        ctx.fillStyle = (index === 25 || index === 16) ? 'blue' : 'red';
        ctx.fill();

      });
    },


    generateFrame() {
      this.frame = {
        x: Math.random() * 0.6 + 0.2, // Random X position (20% to 80% of width)
        y: Math.random() * 0.6 + 0.2, // Random Y position (20% to 80% of height)
        width: 0.3, // 30% of screen width
        height: 0.2, // 20% of screen height
      };
      this.frameStartTime = Date.now();

      clearInterval(this.frameTimer);
      this.frameTimer = setTimeout(() => {
        this.generateFrame(); // Move frame to a new position if not aligned in time
      }, 10000);
    },

    processPose(landmarks) {
      const foodTarget = document.querySelector('.food-target');
      if (!foodTarget) return;
      const canvasElement = document.getElementById('output_canvas');
      const canvasWidth = canvasElement.width;
      const canvasHeight = canvasElement.height;

      // Calculate food position in pixels relative to the canvas
      const foodY = (this.foodPosition.y / 100) * canvasHeight;

      // Extract and calculate key body positions
      const noseY = ((landmarks[7].y + landmarks[8].y) / 2) * canvasHeight;
      const middleBodyX = ((landmarks[11].x + landmarks[12].x) / 2) * canvasWidth;
      const middleBodyY = ((landmarks[11].y + landmarks[12].y) / 2) * canvasHeight;
      const lowerBodyX = ((landmarks[23].x + landmarks[24].x) / 2) * canvasWidth;
      const lowerBodyY = ((landmarks[23].y + landmarks[24].y) / 2) * canvasHeight;

      // Calculate vertical distances from food position
      const distanceToNose = Math.abs(noseY - foodY);
      const distanceToMiddleBody = Math.abs(middleBodyY - foodY);
      const distanceToLowerBody = Math.abs(lowerBodyY - foodY);

      console.log("Distance to nose:", distanceToNose);
      console.log("Distance to middle body:", distanceToMiddleBody);
      console.log("Distance to lower body:", distanceToLowerBody);

      // Compute the body angle based on lower and middle body positions
      const deltaX = lowerBodyX - middleBodyX;
      const deltaY = lowerBodyY - middleBodyY;
      const angleRadians = Math.atan2(deltaY, deltaX);
      const angleDegrees = Math.abs(angleRadians * (180 / Math.PI)); // Convert to degrees
      this.computedAngle = angleDegrees;

      // Determine body state and handle scoring logic
      if (angleDegrees >= 160 || angleDegrees <= 20) {
        // Body is "Up"
        this.isBodyUp = false;
        this.cueMessage = {en:'Up!', el:'Πάνω!', it:'Su!', ro:'Sus!', uk:'Вгору!'};
        this.FoodUpPosition();
        foodTarget.style.display = 'block';
      } else if (!this.isBodyUp && angleDegrees < 160 && angleDegrees > 20) {
        // Body is "Down" and transitioning from "Up"
        this.isBodyUp = true;

        // Award points based on time taken
        const timeTaken = (Date.now() - this.frameStartTime) / 1000;
        if (timeTaken <= 10) {
          const points = Math.max(10 - timeTaken, 0);
          this.score += Math.round(points);
          this.showBadge('success', `+${Math.round(points)} ${this.score_label[this.language]}!`);
          foodTarget.style.display = 'none';

          // Play success sound
          sounds.greanpatch.play();
        }

        // Prepare for the next push-up
        setTimeout(() => {
          this.cueMessage = {en:'Down!', el:'Κάτω!', it:'Giù!', ro:'Jos!', uk:'Вниз!'};
          this.frameStartTime = Date.now();
          this.FoodDownPosition();
          foodTarget.style.display = 'block';
        }, 1000);
      }
    },


    showBadge(type, message) {
      this.badgeType = type;
      this.badgeMessage = message;
      setTimeout(() => {
        this.badgeMessage = '';
      }, 2000);
    },

    async updateSeedPoints(seedType, change) {
  const token = localStorage.getItem("token");
  if (!token) return;

  try {
    const response = await fetch("https://erebus2.athenarc.gr/duse/update-seed-points", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ seedType, change }),
    });

    if (response.ok) {
      console.log(`Seed points updated: ${change} to ${seedType}`);
    } else {
      console.error("Failed to update seed points.");
    }
  } catch (error) {
    console.error("Error updating seed points:", error);
  }
},
    async endGame() {
      let seedType = "";
      let change = 0;

      if (this.score > this.scoreThreshold) {
        change = 1; // Win: Gain a seed
      } else {
        change = -1; // Lose: Lose a seed
      }
      if (sounds.drums_for_games_extended) {
        sounds.drums_for_games_extended.stop();
      }
      if (this.score > this.scoreThreshold) {
        // Play a sound
        sounds.win_sound.play();
      } else {
        // Play a sound
        sounds.lose_sound.play();
      }
      if (this.daypart == 'morning') {
        seedType = "blue";

        if (this.score > this.scoreThreshold) {
          this.overlayMessage = {en:`Congratulations! You scored ${this.score} points!`, el:`Συγχαρητήρια! Η βαθμολογία σου είναι ${this.score} πόντοι!`, it:`Congratulazioni! Hai totalizzato ${this.score} punti!`, ro:`Felicitări! Ai obținut ${this.score} puncte!`, uk:`Вітаємо! Ви набрали ${this.score} балів!`};
          this.isMorningWinOverlayVisible = true; // Show overlay at the end
        } else {
          this.overlayMessage = {en:`You scored ${this.score} points. Try again…`, el:`Συγκέντρωσες ${this.score} πόντους. Προσπάθησε ξανά…`, it:`Hai totalizzato ${this.score} punti. Riprova…`, ro:`Ai obținut ${this.score} puncte. Încearcă din nou…`, uk:`Ви набрали ${this.score} балів. Спробуйте ще раз…`};
          this.isMorningLoseOverlayVisible = true; // Show overlay at the end
        }
      } else if (this.daypart == 'noon') {
        seedType = "red";

        if (this.score > this.scoreThreshold) {
          this.overlayMessage = {en:`Congratulations! You scored ${this.score} points!`, el:`Συγχαρητήρια! Η βαθμολογία σου είναι ${this.score} πόντοι!`, it:`Congratulazioni! Hai totalizzato ${this.score} punti!`, ro:`Felicitări! Ai obținut ${this.score} puncte!`, uk:`Вітаємо! Ви набрали ${this.score} балів!`};
          this.isNoonWinOverlayVisible = true; // Show overlay at the end
        } else {
          this.overlayMessage = {en:`You scored ${this.score} points. Try again…`, el:`Συγκέντρωσες ${this.score} πόντους. Προσπάθησε ξανά…`, it:`Hai totalizzato ${this.score} punti. Riprova…`, ro:`Ai obținut ${this.score} puncte. Încearcă din nou…`, uk:`Ви набрали ${this.score} балів. Спробуйте ще раз…`};
          this.isNoonLoseOverlayVisible = true; // Show overlay at the end
        }
      } else if (this.daypart == 'afternoon') {
        seedType = "green";
        if (this.score > this.scoreThreshold) {
          this.overlayMessage = {en:`Congratulations! You scored ${this.score} points!`, el:`Συγχαρητήρια! Η βαθμολογία σου είναι ${this.score} πόντοι!`, it:`Congratulazioni! Hai totalizzato ${this.score} punti!`, ro:`Felicitări! Ai obținut ${this.score} puncte!`, uk:`Вітаємо! Ви набрали ${this.score} балів!`};
          this.isAfternoonWinOverlayVisible = true; // Show overlay at the end
        } else {
          this.overlayMessage = {en:`You scored ${this.score} points. Try again…`, el:`Συγκέντρωσες ${this.score} πόντους. Προσπάθησε ξανά…`, it:`Hai totalizzato ${this.score} punti. Riprova…`, ro:`Ai obținut ${this.score} puncte. Încearcă din nou…`, uk:`Ви набрали ${this.score} балів. Спробуйте ще раз…`};
          this.isAfternoonLoseOverlayVisible = true; // Show overlay at the end
        }
      } else if (this.daypart == 'night') {
        seedType = "yellow";
        if (this.score > this.scoreThreshold) {
          this.overlayMessage = {en:`Congratulations! You scored ${this.score} points!`, el:`Συγχαρητήρια! Η βαθμολογία σου είναι ${this.score} πόντοι!`, it:`Congratulazioni! Hai totalizzato ${this.score} punti!`, ro:`Felicitări! Ai obținut ${this.score} puncte!`, uk:`Вітаємо! Ви набрали ${this.score} балів!`};
          this.isEveningWinOverlayVisible = true; // Show overlay at the end
        } else {
          this.overlayMessage = {en:`You scored ${this.score} points. Try again…`, el:`Συγκέντρωσες ${this.score} πόντους. Προσπάθησε ξανά…`, it:`Hai totalizzato ${this.score} punti. Riprova…`, ro:`Ai obținut ${this.score} puncte. Încearcă din nou…`, uk:`Ви набрали ${this.score} балів. Спробуйте ще раз…`};
          this.isEveningLoseOverlayVisible = true; // Show overlay at the end
        }
      }
      // Send seed update to the backend
      await this.updateSeedPoints(seedType, change);

      setTimeout(() => {
        this.$router.push({ name: 'GameSelection' }); // Redirect after delay
      }, 3000); // 3 seconds delay
    },

    async storeInIndexedDB(gameState) {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open("GameDB", 1);
    request.onupgradeneeded = function (event) {
      const db = event.target.result;
      if (!db.objectStoreNames.contains("gameStates")) {
        db.createObjectStore("gameStates", { keyPath: "id", autoIncrement: true });
      }
    };

    request.onsuccess = function (event) {
      const db = event.target.result;
      const transaction = db.transaction("gameStates", "readwrite");
      const store = transaction.objectStore("gameStates");

      // Check for existing game state before saving
      const getAllRequest = store.getAll();
      getAllRequest.onsuccess = function () {
        const existingRecords = getAllRequest.result;
        const duplicate = existingRecords.find(
          (record) => record.gameName === gameState.gameName && record.datePlayed === gameState.datePlayed
        );

        if (!duplicate) {
          store.add(gameState);
        } else {
          console.warn("Duplicate game state detected. Skipping save.");
        }

        resolve();
      };

      getAllRequest.onerror = function (event) {
        reject("Error checking existing records:", event.target.error);
      };
    };

    request.onerror = function (event) {
      reject("Error opening IndexedDB:", event.target.error);
    };
  });
}
,

async getUnsyncedGameStates() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open("GameDB", 1);

    request.onsuccess = function (event) {
      const db = event.target.result;
      const transaction = db.transaction("gameStates", "readonly");
      const store = transaction.objectStore("gameStates");

      const getAllRequest = store.getAll();
      getAllRequest.onsuccess = function () {
        resolve(getAllRequest.result);
      };
      getAllRequest.onerror = function (event) {
        reject("Error retrieving game states:", event.target.error);
      };
    };
  });
},

async deleteSyncedGameStates(syncedGames) {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open("GameDB", 1);

    request.onsuccess = function (event) {
      const db = event.target.result;
      const transaction = db.transaction("gameStates", "readwrite");
      const store = transaction.objectStore("gameStates");

      syncedGames.forEach((game) => {
        store.delete(game.id); // Delete only specific records
      });

      resolve();
    };

    request.onerror = function (event) {
      reject("Error clearing IndexedDB:", event.target.error);
    };
  });
}
,
async syncWithMongo() {
  if (this.isSyncing) return; // Prevent duplicate sync
  this.isSyncing = true;

  const token = localStorage.getItem("token");
  if (!token) {
    console.error("User not authenticated. Cannot sync.");
    this.isSyncing = false;
    return;
  }

  try {
    const unsyncedGames = await this.getUnsyncedGameStates();
    if (unsyncedGames.length === 0) {
      console.log("No game states to sync.");
      this.isSyncing = false;
      return;
    }

    const response = await fetch("https://erebus2.athenarc.gr/duse/save-game-state", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ gameStates: unsyncedGames }),
    });

    if (response.ok) {
      console.log("Game states synced successfully.");
      await this.deleteSyncedGameStates(unsyncedGames);
    } else {
      console.error("Failed to sync game states.");
    }
  } catch (error) {
    console.error("Error syncing with MongoDB:", error);
  } finally {
    this.isSyncing = false; // Ensure flag is reset
  }
},
    async saveGameState() {
  const token = localStorage.getItem("token");
  const username = localStorage.getItem("username");

  if (!username) {
    console.error("User not logged in. Cannot save game state.");
    return;
  }

  const gameState = {
    username,
    gameName: this.$route.name,
    score: this.score,
    datePlayed: new Date().toISOString(),
  };

  try {
    // Store in IndexedDB regardless of network status
    await this.storeInIndexedDB(gameState);

    if (navigator.onLine && token) {
      await this.syncWithMongo();
    } else {
      console.warn("No internet connection. Game state saved locally.");
    }
  } catch (error) {
    console.error("Error saving game state:", error);
  }
},

  },
  created()
  {
    this.language = localStorage.getItem("language") || "en"; // Default to English
    console.log("LANGUAGE "+this.language);
  },
  mounted() {
    console.log("Current route path:", this.$route.path);

    const daypart = this.$route.path.split("/")[2] || "daypart";
    this.daypart = daypart;
    this.startGame();

    // Check for internet connectivity
    window.addEventListener("online", async () => {
      console.log("Back online! Syncing game states...");
      await this.syncWithMongo();
    });

    sounds.drums_for_games_extended.loop(true);
    sounds.drums_for_games_extended.volume(0.5);
    sounds.are_you_ready_brian.play();
  },
  beforeUnmount() {
    clearInterval(this.timer);
    if (this.camera) {
      try {
        this.camera.stop();
      } catch (e) {
        console.error("Camera stop failed on unmount:", e);
      }
    }

    // Optionally nullify the camera and pose to prevent further usage
    this.camera = null;

    if (this.pose) {
      this.pose.close(); // dispose pose properly if using pose.setOptions() instance
      this.pose = null;
    }
    if (sounds.drums_for_games_extended) {
      sounds.drums_for_games_extended.stop();
    }
    this.saveGameState();
  },
  beforeRouteLeave(to, from, next) {
    // Save game state when the user navigates away
    this.saveGameState();
    next();
  },

};
</script>

<style scoped>
.hands-container {
  position: relative;
  width: 100vw;
  height: 100vh;
  background-size: cover;
}

.ar-view {
  position: relative;
  width: 100%;
  height: 100%;
}

video,
canvas {
  position: absolute;
  top: 0;
  left: 0;
  width: auto;
  /* Maintain aspect ratio */
  height: 100%;
  /* Full height of the screen */
  object-fit: cover;
  /* Avoid distortion */
  transform: scaleX(-1);
  /* Mirror for selfie mode */
}

.game-stats {
  position: absolute;
  top: 70px;
  /* Fixed position to prevent being pushed */
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  /* Higher than video and canvas */
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 90%;
  margin: 0 auto;
  padding: 10px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 8px;
  color: white;
  font-size: 20px;
}

.cue-message {
  position: absolute;
  top: 170px;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 24px;
  color: white;
  background-color: rgba(0, 0, 0, 0.7);
  padding: 10px 20px;
  border-radius: 10px;
  text-align: center;
}

.badge {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 24px;
  color: white;
  padding: 10px 20px;
  border-radius: 10px;
  text-align: center;
}

.badge.success {
  background-color: green;
}

.back-button {
  z-index: 1001;
}


.food-target {
  position: absolute;
  width: 100px;
  height: 100px;
  transform: translate(-50%, -50%);
}

/* .angle-display {
  position: absolute;
  top: 270px;
  left: 50%;
  justify-content: space-between;
  transform: translateX(-50%);
  z-index: 10;
  display: flex;
  align-items: center;
  width: 90%;
  margin: 0 auto;
  padding: 10px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 8px;
  color: white;
  font-size: 20px;
} */
</style>